export { default as getLinkHref } from './getLinkHref';
export { default as getPageURI } from './getPageURI';
